import { ChannelFilter } from '../consts/channel-filter';

export function SETTINGS_CHANNEL(channel?: ChannelFilter) {
  return `ping-settings-channel-section-${channel || ''}`;
}

export function SETTINGS_GROUP_ROW(groupKey: string) {
  return `ping-settings-group-row-${groupKey}`;
}

export function SETTINGS_GROUP_TOGGLE_SWITCH(sectionKey: string, groupKey: string) {
  const section = sectionKey.toLowerCase().replace(/ /g, '_');
  return `ping-settings-group-toggle-switch-${section}-${groupKey}`;
}
